// extracted by mini-css-extract-plugin
export default {"form-card":"Common_form-card__E5SZR","form-title":"Common_form-title__ZLaFD","form-actions":"Common_form-actions__nPfXB"};